import { InstoreCartControllerWrapper as InstoreCartController } from 'src/payments/instore-cart/instore-cart-controller/instore-cart-controller';

export default InstoreCartController;
